module.exports = __webpack_public_path__ + "static/media/Ionicons.b3263095.ttf";